import {gql} from '@apollo/client';

export const CREATE_PICKUP_ROUTE = gql`
  mutation CreatePickupRoute($input: CreatePickupRouteInput!) {
    createPickupRoute(input: $input) {
      id
      routeName
      warehouseId
      zipcodesListJson
      driverId
      vehicleId
      createdAt
      updatedAt
      isDeleted
    }
  }
`;